import { restApi } from '../../api/restApiSlice';

export const addedDomainsApiSlice = restApi.injectEndpoints({
  tagTypes: ['addedDomains'],
  endpoints: (builder) => ({
    getAddedDomains: builder.query({
      query: (params) => ({ url: '/v3/domain-statistics/added', method: 'GET', params }),
      providesTags: ['addedDomains'],
    }),
  }),
});

export const { useGetAddedDomainsQuery } = addedDomainsApiSlice;
